let verifyGooglebot = null;
if (!process.browser) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const verify = require("googlebot-verify");
  verifyGooglebot = verify;
}

export default verifyGooglebot;
